import {
    AccountStatus,
    App,
    accountSourceDataTypeChecker,
    getAccounts,
} from 'owa-account-source-list-store';
import type { MailboxInfo } from 'owa-client-types';
import { isPstFileMailboxInfo } from 'owa-client-types/lib/PstFileMailboxInfo';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export default function shouldShowAllPstFilesScope(selectedMailboxInfo?: MailboxInfo): boolean {
    return (
        isPstFileMailboxInfo(selectedMailboxInfo) &&
        isGlobalFeatureEnabled('sea-multiPstSearch') &&
        getAccounts(AccountStatus.Completed, App.Mail).filter(account =>
            accountSourceDataTypeChecker.isPstFile(account)
        ).length > 1
    );
}
